// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vQz-","questions":"styles_questions__C-3QX","footer":"styles_footer__1LviQ"};